import ATableAccess from "./aTableAccess";

class WorkprocessAccess extends ATableAccess {}

export default WorkprocessAccess;
